export default __webpack_public_path__ + "static/media/guest_13_01_ale_santos.7c102aee.png";